import { post, get, postStore } from '@/utils/http/http'
import { BILL_API_URL, SHOP_URL, LIVE_GW_URL } from '@/utils/http/baseUrl'
// 大健康 - 门店系统相关控制器与组件
import StoreController from '@/controllers/storeController/view/store/store.controller.js'
import StoreApiController from '@/controllers/storeController/view/store/storeApi.controller.js'
const formatVerifyStatusList = data => {
  let result = JSON.parse(JSON.stringify(data))
  if (!Array.isArray(result.verifyStatusList)) {
    if (typeof result.verifyStatus === 'number') {
      result.verifyStatusList = [result.verifyStatus]
    }

    if (Array.isArray(result.verifyStatus)) {
      result.verifyStatusList = result.verifyStatus
    }
  }
  if (
    Array.isArray(result.verifyStatusList) &&
    result.verifyStatusList.includes(6)
  ) {
    // 退款中兼容 熊刚说退款中要多加传一个3
    result.verifyStatusList.push(3)
  }
  // 熊刚说不要传了
  delete result.verifyStatus
  return result
}
// 获取用户代理订单列表
export const GetMyAgentOrderList = d => {
  const isStore = StoreController.isStore()
  let data = formatVerifyStatusList(d, isStore)
  if (isStore) {
    data = StoreApiController.GetMyAgentOrderListParams(data)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(`${BILL_API_URL}/api/AgentOrder/GetMyAgentOrderList`, data)
}

// 代理-订单统计-获取最近N个搜索商品
export const GetLatestSearchContent = data => {
  const isStore = StoreController.isStore()
  if (isStore) {
    data = StoreApiController.GetLatestSearchContentParams(data)
  }
  const $apiPost = isStore ? postStore : post
  return $apiPost(`${BILL_API_URL}/api/AgentOrder/GetLatestSearchContent`, data)
}

// 获取用户代理订单详情
export const GetAgentOrderData = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  return $apiPost(`${BILL_API_URL}/api/AgentOrder/GetAgentOrderData`, data)
}

// 核销订单
export const PostVerifyGoods = data => {
  const isStore = StoreController.isStore()
  const $apiPost = isStore ? postStore : post
  if (isStore) {
    data = {
      ...data,
      verifyFrom: 'storedirector',
    }
  }
  return $apiPost(
    `${SHOP_URL}/api/v1/wx/verify/set_code_verify_new`,
    data,
    false,
    {
      allRes: true,
    }
  )
}

// 订单业绩导出
export const ExportAgentOrderList = d => {
  const isStore = StoreController.isStore()
  let data = formatVerifyStatusList(d, isStore)
  if (isStore) {
    data = StoreApiController.ExportAgentOrderListParams(data)
  }
  return isStore
    ? postStore(`${BILL_API_URL}/api/AgentOrder/ExportAgentOrderList`, data)
    : post(`${BILL_API_URL}/api/AgentOrder/ExportAgentOrderList`, data)
}

// 代理订单退款审核列表
export const GetAgentOrderRefundList = data =>
  post(`${BILL_API_URL}/api/AgentOrder/GetAgentPostSaleList`, data)

// 代理订单退款审核详情
export const GetAgentOrderRefundData = data =>
  post(`${BILL_API_URL}/api/AgentOrder/GetAgentPostSaleData`, data)
/**
 * 代理-订单业绩-聚合
 * @param {
  "deliveryType": 0, 	配送方式 空 | 0 | -1 表示全部 1:商家配送 2:门店自提 10:常规核销 11:门店核销
  "endTime": "",
  "followId": 0,
  "followLevel": 0, 身份 0：全部，1：一级代理身份，2：二级代理身份
  "orderStatus": 0,
  "startTime": "",
  "topicId": 0,
  "zbId": 0
}
 * @returns {*|Promise|Promise<unknown>}
 */
export const getOrderPerformanceSum = d => {
  let data = formatVerifyStatusList(d)
  return post(
    `${LIVE_GW_URL}/health/v1/h5/agent-data/getOrderPerformanceSum`,
    data
  )
}

// 代理售后订单统计
export const GetAgentPostSaleStatistics = data =>
  post(`${BILL_API_URL}/api/AgentOrder/GetAgentPostSaleListCount`, data)

// 代理售后订单数量
export const GetAgentPostSaleCount = data =>
  post(`${BILL_API_URL}/api/AgentOrder/GetAgentPostSaleCount`, data)

// 查询代理中心订单列表样式
export const getAgentOrderUserType = data =>
  get(`${BILL_API_URL}/api/AgentOrder/GetAgentOrderUserType`, data)

// 保存代理中心订单列表样式
export const saveAgentOrderUserType = data =>
  post(`${BILL_API_URL}/api/AgentOrder/SaveAgentOrderUserType`, data)

// 查看直播间是否开启客户订单查询90天灰度
export const getAgentCustomerOrderGray = data =>
  get(`${BILL_API_URL}/api/AgentOrder/GetAgentOrderTimeGray`, data)

// 查看直播间是否开启根据商品名称模糊搜索灰度
export const getAgentOrderGray = data =>
  get(`${BILL_API_URL}/api/AgentOrder/AgentOrderGray`, data)

// 获取提货码订单样式
export const getAgentDeliveryOrderUserType = data =>
  get(`${BILL_API_URL}/api/AgentOrder/GetAgentDeliveryOrderUserType`, data)

// 保存提货码订单样式
export const saveAgentDeliveryOrderUserType = data =>
  post(`${BILL_API_URL}/api/AgentOrder/SaveAgentDeliveryOrderUserType`, data)
// 代理售后导出
export const afterSaleExport = data =>
  post(`${BILL_API_URL}/api/AgentOrder/ExportAgentPostSaleTask`, data)
